import { createNode } from '@glueapp/graph-types';

export const SplitPath = createNode({
    id: 'Split Path',
    name: 'Split Path',
    description: 'A Node for splitting the execution into different paths',
    aiDescription:
        'Splits execution into two mutually exclusive paths based on a boolean condition (hasExecutionDecisions=true).\n' +
        'Connect any value to "Value" and a boolean to "Condition".\n' +
        'Both output ports ("Path if True" and "Path if False") carry the same Value, but only the matching path executes downstream nodes.\n' +
        'Use this when you need conditional branching where different downstream subgraphs run depending on the condition.',
    category: 'Flow Control',
    color: '#869094',
    hasExecutionDecisions: true,
    inPorts: {
        Value: {
            kind: 'generic',
            identifier: 'K',
        },
        Condition: {
            kind: 'boolean',
        },
    },
    outPorts: {
        'Path if True': { kind: 'generic', identifier: 'K' },
        'Path if False': { kind: 'generic', identifier: 'K' },
    },
    execute: function (input) {
        return {
            output: {
                'Path if True': input.inPorts.Value,
                'Path if False': input.inPorts.Value,
            },
            executionDecisions: {
                'Path if True': input.inPorts.Condition,
                'Path if False': !input.inPorts.Condition,
            },
        };
    },
});
